import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const IMG = "https://images.unsplash.com/photo-1680359873864-43e89bf248ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); nav("/"); }
    catch (err) { setError(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FBFAF7]">
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <div className="h-12 w-12 rounded-xl bg-amber-600 text-white grid place-items-center font-extrabold text-xl">M</div>
          <h1 className="mt-8 text-4xl font-extrabold tracking-tight text-slate-900">Welcome back</h1>
          <p className="mt-2 text-sm text-slate-500">Manjap Hospitality Solutions — sales & expense CRM</p>
          <div className="mt-10 space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input" className="h-11 bg-white" placeholder="you@manjap.in" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="pw">Password</Label>
              <Input id="pw" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input" className="h-11 bg-white" />
            </div>
            {error && <p className="text-sm text-rose-600" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={busy} data-testid="login-submit-button"
              className="w-full h-11 bg-amber-600 hover:bg-amber-700 text-white font-semibold">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
            </Button>
          </div>
        </form>
      </div>
      <div className="hidden lg:block relative">
        <img src={IMG} alt="Paratha thali" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/10 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="text-xs uppercase tracking-[0.25em] text-amber-200">Manjap Hospitality Solutions</div>
          <div className="mt-3 text-4xl font-extrabold tracking-tight">Good Food. Great Mood.</div>
          <p className="mt-3 text-sm text-white/80 max-w-md">Every plate, every rupee — tracked day by day, shift by shift.</p>
        </div>
      </div>
    </div>
  );
}
